var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 605,
    viewBox: "0 0 830 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter0_f_531_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.934 288.616L157.209 374.727C144.038 399.001 151.423 429.307 174.285 444.8C187.129 453.505 203.11 456.229 218.112 452.271L356.732 415.705C387.449 407.602 419.083 403.5 450.85 403.5H631.807C634.265 403.5 636.72 403.31 639.149 402.933C672.723 397.715 690.291 360.122 672.755 331.019L662.5 314L647.487 284.419C624.403 238.938 587.73 201.773 542.56 178.086L529.082 171.018C502.754 157.212 473.47 150 443.742 150C407.086 150 371.269 160.963 340.892 181.478L303.997 206.397C296.016 211.787 287.551 216.422 278.71 220.241C246.83 234.014 220.497 258.092 203.934 288.616Z",
    fill: "url(#paint0_linear_531_110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_110",
    x: 0.70166,
    y: 0,
    width: 828.957,
    height: 604.049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_531_110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_110",
    x1: 469.5,
    y1: 385.5,
    x2: 299.5,
    y2: -10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector5.3509a3cbe3f19935eba8db3edf65b967.svg";
export { ForwardRef as ReactComponent };